export enum PROCESSING_STATUS {
	PENDING = 'pending',
	APPROVED = 'approved',
	REJECTED = 'rejected',
}

export const PROCESSING_STATUS_OPTIONS = [
	{ label: 'Chờ duyệt', value: PROCESSING_STATUS.PENDING },
	{ label: 'Đã duyệt', value: PROCESSING_STATUS.APPROVED },
	{ label: 'Từ chối', value: PROCESSING_STATUS.REJECTED },
]

export enum TRANSACTION_TYPE {
	SELL = 'sell',
	RENT = 'rent',
}
export const TRANSACTION_TYPE_OPTIONS = [
	{ label: 'Bán', value: TRANSACTION_TYPE.SELL },
	{ label: 'Cho thuê', value: TRANSACTION_TYPE.RENT },
]

export enum LISTING_TYPE {
	CLASSIFIED = 'classified',
	OWNER = 'owner',
	EXCLUSIVE = 'exclusive',
}

export const LISTING_TYPE_OPTIONS = [
	{ label: 'Tin môi giới', value: LISTING_TYPE.CLASSIFIED, color: 'secondary' },
	{ label: 'Tin chính chủ', value: LISTING_TYPE.OWNER, color: 'info' },
	{ label: 'Tin độc quyền', value: LISTING_TYPE.EXCLUSIVE, color: 'warn' },
]

export enum REAL_ESTATE_CATEGORY {
	APARTMENT = 'apartment',
	HOUSE = 'house',
	HOUSE_IN_ALLEY = 'house_in_alley',
	LAND = 'land',
	SHOPHOUSE = 'shop_house',
	VILLA = 'villa',
	CONDOTEL = 'condotel',
	OFFICE = 'office',
	OTHER = 'other',
	HOSLET = 'hostel',
}

export const REAL_ESTATE_CATEGORY_OPTIONS = [
	{ label: 'Căn hộ', value: REAL_ESTATE_CATEGORY.APARTMENT },
	{ label: 'Nhà mặt phố', value: REAL_ESTATE_CATEGORY.HOUSE },
	{ label: 'Nhà trong ngõ', value: REAL_ESTATE_CATEGORY.HOUSE_IN_ALLEY },
	{ label: 'Đất nền', value: REAL_ESTATE_CATEGORY.LAND },
	{ label: 'Shop house', value: REAL_ESTATE_CATEGORY.SHOPHOUSE },
	{ label: 'Biệt thự', value: REAL_ESTATE_CATEGORY.VILLA },
	{ label: 'Condotel', value: REAL_ESTATE_CATEGORY.CONDOTEL },
	{ label: 'Văn phòng', value: REAL_ESTATE_CATEGORY.OFFICE },
	{ label: 'Phòng trọ', value: REAL_ESTATE_CATEGORY.HOSLET },
	{ label: 'Khác', value: REAL_ESTATE_CATEGORY.OTHER },
]

export const USAGE_AREA = [
	REAL_ESTATE_CATEGORY.APARTMENT,
	REAL_ESTATE_CATEGORY.HOUSE,
	REAL_ESTATE_CATEGORY.HOUSE_IN_ALLEY,
	// REAL_ESTATE_CATEGORY.LAND,
	REAL_ESTATE_CATEGORY.SHOPHOUSE,
	REAL_ESTATE_CATEGORY.VILLA,
	REAL_ESTATE_CATEGORY.CONDOTEL,
	REAL_ESTATE_CATEGORY.OFFICE,
	REAL_ESTATE_CATEGORY.OTHER,
	REAL_ESTATE_CATEGORY.HOSLET,
]

export enum DIRECTION {
	EAST = 'east',
	WEST = 'west',
	SOUTH = 'south',
	NORTH = 'north',
	NORTHEAST = 'northeast',
	NORTHWEST = 'northwest',
	SOUTHEAST = 'southeast',
	SOUTHWEST = 'southwest',
}

export const DIRECTION_OPTIONS = [
	{ label: 'Đông', value: DIRECTION.EAST },
	{ label: 'Tây', value: DIRECTION.WEST },
	{ label: 'Nam', value: DIRECTION.SOUTH },
	{ label: 'Bắc', value: DIRECTION.NORTH },
	{ label: 'Đông Bắc', value: DIRECTION.NORTHEAST },
	{ label: 'Tây Bắc', value: DIRECTION.NORTHWEST },
	{ label: 'Đông Nam', value: DIRECTION.SOUTHEAST },
	{ label: 'Tây Nam', value: DIRECTION.SOUTHWEST },
]

// unlisted: "--", listing: "Đang list", active: "Đang rao", flash_offer: "Flash offer"
export enum LISTING_STASTUS {
	LISTING = 'listing',
	ACTIVE = 'active',
	FLASH_OFFER = 'flash_offer',
}

export const LISTING_STATUS_OPTIONS = [
	{ label: 'Đang list', value: LISTING_STASTUS.LISTING },
	{ label: 'Đang rao', value: LISTING_STASTUS.ACTIVE },
	{ label: 'Flash offer', value: LISTING_STASTUS.FLASH_OFFER },
]

// pending, approved, rejected, completed, expired
export enum LISTING_PROCESSING_STATUS {
	PENDING = 'pending',
	APPROVED = 'approved',
	REJECTED = 'rejected',
	COMPLETED = 'completed',
	EXPIRED = 'expired',
}

export const LISTING_PROCESSING_STATUS_OPTIONS = [
	{ label: 'Chờ duyệt', value: LISTING_PROCESSING_STATUS.PENDING, color: 'warn' },
	{ label: 'Đã duyệt', value: LISTING_PROCESSING_STATUS.APPROVED, color: 'success' },
	{ label: 'Từ chối', value: LISTING_PROCESSING_STATUS.REJECTED, color: 'danger' },
	{ label: 'Hoàn thành', value: LISTING_PROCESSING_STATUS.COMPLETED, color: 'success' },
	{ label: 'Hết hạn', value: LISTING_PROCESSING_STATUS.EXPIRED, color: 'secondary' },
]

export enum PRICE_TYPE {
	FIXED_PRICE = 'fixed_price',
	SQM_PMONTH = 'sqm_pmonth',
	PMONTH = 'pmonth',
}

export const PRICE_TYPE_OPTIONS = [
	{ label: 'cố định', value: PRICE_TYPE.FIXED_PRICE },
	{ label: 'm2/tháng', value: PRICE_TYPE.SQM_PMONTH },
	{ label: 'mỗi tháng', value: PRICE_TYPE.PMONTH },
]
